import styled from 'styled-components';

const CampaignsPageStyle = styled.div`
  padding: 0px;
  color: white;
  min-height: calc(100vh - 64px);
  background: #0b0f1b;
  display: flex;
  flex-direction: column;
`;

const CampaignsHeader = styled.div`
  background: #0b0f1b;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px 0 32px;

  .campaigns-header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;

    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }

  .campaigns-title-section {
    text-align: center;
    margin-bottom: 32px;

    .campaigns-page-title {
      font-size: 48px;
      font-weight: 700;
      color: white;
      margin: 0 0 12px 0;
      font-family: 'Poppins', sans-serif;
      background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      line-height: 1.1;
      padding-bottom: 4px;
      margin-top: 0;
      letter-spacing: -0.02em;

      @media (max-width: 1600px) {
        font-size: 36px;
      }

      @media (max-width: 1400px) {
        font-size: 28px;
        line-height: 1;
        margin-bottom: 4px;
      }

      @media (max-width: 1024px) {
        font-size: 28px;
      }

      @media (max-width: 768px) {
        font-size: 24px;
      }

      @media (max-width: 480px) {
        font-size: 20px;
      }
    }

    .campaigns-page-subtitle {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.7);
      margin: 0;
      font-weight: 400;
      font-family: 'Poppins', sans-serif;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.5;
      letter-spacing: -0.01em;

      @media (max-width: 1600px) {
        font-size: 16px;
      }

      @media (max-width: 1400px) {
        font-size: 14px;
        line-height: 1.4;
      }

      @media (max-width: 1024px) {
        font-size: 14px;
      }

      @media (max-width: 768px) {
        font-size: 13px;
      }

      @media (max-width: 480px) {
        font-size: 12px;
      }
    }
  }

  .campaigns-controls-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 1600px) {
      gap: 14px;
    }

    @media (max-width: 1400px) {
      gap: 12px;
    }

    @media (max-width: 1024px) {
      gap: 16px;
      flex-wrap: wrap;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 16px;
    }

    @media (max-width: 480px) {
      gap: 12px;
    }
  }

  .campaign-offer-panel {
    margin: 0;
    padding: 24px;
    background: linear-gradient(135deg, #111823 0%, #0f172a 50%, #111823 100%);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(20px);
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.3),
      0 4px 16px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
    position: relative;
    overflow: hidden;
    max-width: 600px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 14px;
      border-radius: 10px;
    }

    @media (max-width: 480px) {
      padding: 12px;
      border-radius: 8px;
    }

    .setup-step-card {
      margin-top: 0;
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid rgba(29, 185, 84, 0.22);
      background: linear-gradient(
        135deg,
        rgba(29, 185, 84, 0.08) 0%,
        rgba(255, 255, 255, 0.03) 55%,
        rgba(255, 255, 255, 0.02) 100%
      );
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
      display: flex;
      align-items: flex-start;
      gap: 12px;

      @media (max-width: 768px) {
        padding: 12px 14px;
        gap: 10px;
      }
    }

    .setup-step-card--offer {
      border-color: rgba(111, 178, 255, 0.22);
      background: linear-gradient(
        135deg,
        rgba(111, 178, 255, 0.08) 0%,
        rgba(255, 255, 255, 0.03) 55%,
        rgba(255, 255, 255, 0.02) 100%
      );
    }

    .setup-step-card__icon {
      flex-shrink: 0;
      width: 36px;
      height: 36px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1ed760;
      background: rgba(29, 185, 84, 0.14);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
    }

    .setup-step-card__body {
      min-width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .setup-step-card__title {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.35;
      color: rgba(255, 255, 255, 0.92);
      font-family: 'Poppins', sans-serif;
      text-wrap: balance;
    }

    .setup-step-card__text {
      margin: 0;
      font-size: 13px;
      line-height: 1.45;
      color: rgba(255, 255, 255, 0.62);
      font-family: 'Poppins', sans-serif;
      text-wrap: pretty;
    }

    .setup-step-card__spotify-btn,
    .setup-step-card__offer-btn {
      align-self: flex-start;
      margin-top: 6px;
      min-height: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border: none;
      border-radius: 999px;
      padding: 8px 16px;
      font-size: 13px;
      font-weight: 600;
      font-family: 'Poppins', sans-serif;
      cursor: pointer;
      transition-property: transform, box-shadow, background, border-color;
      transition-duration: 0.2s;
      transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    }

    .setup-step-card__spotify-btn {
      background: linear-gradient(135deg, #1db954 0%, #1ed760 100%);
      color: #fff;
      box-shadow: 0 4px 14px rgba(29, 185, 84, 0.28);

      &:hover {
        box-shadow: 0 6px 18px rgba(29, 185, 84, 0.38);
      }

      &:active {
        transform: scale(0.96);
      }
    }

    .setup-step-card__offer-btn {
      border: 1px solid rgba(111, 178, 255, 0.45);
      background: rgba(111, 178, 255, 0.12);
      color: #e9f2ff;
      text-decoration: none;

      &:hover {
        background: rgba(111, 178, 255, 0.18);
        border-color: rgba(111, 178, 255, 0.7);
        color: #e9f2ff;
      }

      &:active {
        transform: scale(0.96);
      }
    }

    .offer-summary-card {
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.08);
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.04));
      backdrop-filter: blur(10px);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
      display: flex;
      flex-direction: column;
      gap: 10px;

      @media (max-width: 768px) {
        padding: 12px 14px;
        gap: 8px;
      }
    }

    .offer-summary-card__header {
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.92);
      font-family: 'Poppins', sans-serif;
    }

    .offer-summary {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .offer-summary__row {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      line-height: 1.4;

      @media (max-width: 480px) {
        align-items: flex-start;
      }
    }

    .offer-summary__label {
      color: rgba(255, 255, 255, 0.65);
      min-width: 90px;
      font-weight: 500;
    }

    .offer-summary__value {
      color: #ffffff;
      font-weight: 600;
    }
  }
`;

const CampaignsContent = styled.div`
  flex: 1;
  padding: 0;

  .campaigns-section-wrapper {
    padding: 0px 0 120px 0;

    @media (max-width: 768px) {
      padding: 20px 0;
    }
  }

  .campaigns-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));
    gap: 24px;
    padding: 0 24px;
    margin: 0 auto;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      padding: 0 16px;
      gap: 16px;
    }

    @media (max-width: 480px) {
      padding: 0 12px;
    }
  }

  .campaigns-disabled-message,
  .no-campaigns-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    background-color: #111823;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    max-width: 600px;
    margin: 40px auto;

    @media (max-width: 768px) {
      padding: 40px 20px;
      margin: 20px auto;
    }
  }

  .disabled-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
    color: #666;

    @media (max-width: 768px) {
      width: 48px;
      height: 48px;
      margin-bottom: 16px;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .campaigns-disabled-message h3,
  .no-campaigns-message h3 {
    font-size: 24px;
    font-weight: 700;
    color: white;
    margin: 0 0 16px 0;
    font-family: 'Poppins', sans-serif;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  .campaigns-disabled-message p,
  .no-campaigns-message p {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 8px 0;
    line-height: 1.5;
    font-family: 'Poppins', sans-serif;
    max-width: 500px;

    a {
      color: #93c5fd;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .campaigns-disabled-message p:last-child,
  .no-campaigns-message p:last-child {
    margin-bottom: 0;
  }

  .existing-campaigns-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    margin-bottom: 24px;
    background-color: rgba(255, 193, 7, 0.1);
    border: 1px solid rgba(255, 193, 7, 0.3);
    border-radius: 12px;
    color: #ffc107;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    backdrop-filter: blur(10px);

    @media (max-width: 768px) {
      padding: 12px;
      gap: 10px;
      margin-bottom: 16px;
    }

    .notice-icon {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-top: 2px;

      @media (max-width: 768px) {
        width: 18px;
        height: 18px;
      }

      svg {
        width: 100%;
        height: 100%;
        color: #ffc107;
      }
    }

    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      color: #ffc107;
      font-family: 'Poppins', sans-serif;

      a {
        color: #ffdb4d;
        text-decoration: underline;
      }

      @media (max-width: 768px) {
        font-size: 13px;
      }
    }

    strong {
      font-weight: 600;
      color: #ffdb4d;
    }
  }
`;

export { CampaignsPageStyle, CampaignsHeader, CampaignsContent };
